import { Page } from './Pages'

export const navigations = [
	Page.dashboard,
	Page.housing_cooperative,
	Page.water_maters,
	Page.measurement,
	Page.alerts,
	Page.constAllocation,
	Page.chirpStack,
	Page.users,
	Page.documents,
	Page.contact
]
